module.exports = __webpack_public_path__ + "static/img/ent-detail-5.db4415c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-5.jpg
// module id = RHgf
// module chunks = 52